import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const messages = {
  es: {
    MSAUTH01: "Iniciar sesión",
    MSAUTH02: "Email",
    login: {
      losientoError:
        "Lo sentimos, se ha producido un error al intentar validar tu usuario",
      tokenExpiradoConfirmar:
        "Su token ha expirado. Hemos reenviado el correo de validación para que pueda completar el proceso",
      entendido: "Entendido",
      acceder: "y poder acceder a ella.",
      debeconsultar:
        "Debe consultar el email para completar el proceso de validación",
      sucuentaseha:
        "Su cuenta se ha creado con éxito pero aún no está validada.",
      verifucaCuenta: "Verifica tu cuenta",
      incio: "Ir al inicio",
      noseharegistadotodavia: "¿No estás registrado todavía?",
      olvidastesTuContraseña: "¿Olvidaste tu contraseña?",
      olvido: "Recuperar contraseña",
      olvidoContraseña: "olvido su contraseña",
      newContraseña: "Recuperar contraseña",
      blockingContraseña: "Desbloquear contraseña",
      recuperarContraseña: "Recuperar contraseña",
      solicitudDeCambio: "La solicitud fue satisfactoria",
      cambioExitosoTitle: "Cambio de clave satisfactorio",
      verificarCorreo:
        "La petición de recuperación de contraseña se realizó de forma satisfactoria",
      cambioExitoso:
        "Su cambio fue satisfactorio, por favor ingrese nuevamente",
      aceptar: "Aceptar",
      Contraseña: "Contraseña",
      Crearcontra: "Crear una cuenta",
      cookes:
        " “Caja Rural de Navarra, Sociedad Cooperativa de Crédito no utiliza cookies para recoger información de las personas usuarias. Únicamente se utilizan cookies propias, de sesión, con finalidad técnica (aquellas que permiten al usuario la navegación a través del sitio web y la utilización de las diferentes opciones y servicios que en ella existen). El portal del que es titular Caja Rural de Navarra, Sociedad Cooperativa de Crédito contiene enlaces a sitios web de terceros, cuyas políticas de privacidad son ajenas a la de Caja Rural de Navarra, Sociedad Cooperativa de Crédito. Al acceder a tales sitios web, usted puede decidir si acepta sus políticas de privacidad y de cookies. Con carácter general, si navega por internet usted puede aceptar o rechazar las cookies de terceros desde las opciones de configuración de su navegador.”",
      titleCookes: "POLÍTICA DE COOKIES",
    },

    errors: {
      400: "Solicitud no valida",
      600: "En este momento no podemos validar los datos suministrados",
      601: "Error al crear el usuario",
      602: "Error al validar la cuenta",
      603: "El correo electrónico no coincide con el correo electrónico registrado",
      604: "El proveedor no coincide con el registrado",
      605: "El usuario con correo electrónico que está intentando registrarse ya ha sido verificado pero está bloqueado",
      606: "Error al validar la cuenta. No se encontraron resultados de usuario con criterios de búsqueda",
      607: "Error en el servicio de búsqueda de usuarios",
      608: "No se encontraron resultados con los criterios de búsqueda",
      609: "Error usuario",
      610: "No se a encontraron resultados de usuario con los criterios de búsqueda",

      611: "Error al eliminar el usuario",
      612: "No se puede eliminar una usuario principal",
      613: "El usuario no puede eliminarse a sí mismo",
      614: "Error al eliminar proveedor de usuario",
      615: "No se encontraron resultados de usuario con los criterios de búsqueda",
      616: "En este momento no podemos verificar la data del usuario, intente más tarde",
      617: "El usuario ya ha sido verificado",
      618: "Email no válido, ya existe usuario",
      619: "La contraseña no puede tener los mismos caracteres consecutivos",

      620: "La contraseña no puede contener un alias de usuario",
      621: "Formato de fecha incorrecto",
      622: "Error al enviar la validación de correo electrónico",
      623: "Error al enviar correo electrónico de usuario registrado ",
      624: "Error al enviar al email la nueva contraseña",
      625: "Error al enviar al email el cambio de contraseña",
      626: "Contraseña expirada, revise su email para efectuar el proceso de recuperación.",
      627: "Cuenta bloqueada",
      628: "Error al registrar el email",
      629: "Usuario inactivo",
      630: "Erros en el servicio",

      631: "El usuario no puede registrarse como usuario principal ya que no puede haber más de un usuario con esta característica",
      632: "Usuario no encontrado",
      633: "La contraseña actual del usuario es incorrecta",
      634: "La contraseña del usuario está en las últimas contraseñas usadas",
      635: "Su cuenta no ha sido validada. Hemos reenviado el correo de validación para que pueda completar el proceso",
      636: "Ha sido bloqueado por tener intentos fallidos",
      637: "Has introducido una contraseña incorrecta",
      638: "Su contraseña ha expirado",
      639: "El usuario no coincide con la entidad",

      640: "El email actual y el nuevo email son iguales",
      641: "El email ya existe",
      642: "Datos perdidos",
      643: "La contraseña actual y la nueva contraseña son iguales",
      644: "La contraseña debe contener al menos 1 letra mayúscula y una letra minúscula",
      645: "La contraseña debe contener al menos 2 caracteres no alfabéticos",
      646: "La contraseña no puede tener caracteres de comillas",
      647: "La contraseña solo debe contener caracteres alfabéticos, espacios en blanco, números y los siguientes caracteres especiales: < + | & ! * - % _ > ? : =",
      648: "La longitud de la contraseña debe tener entre 12 y 30 caracteres",
      649: "Solo uno de los campos Sms o Email, debe marcarse como verdadero",
      650: "Usuario Bloqueado, verifique su correo para poder desbloquearlo",
      680: "Usuario Requerido",
      681: "la longitud del campo debe tener entre 8 y 9 caracteres",
      683: "La entidad debe ser la mismo del usuario que inició sesión",
      684: "El codigo de proveedor debe ser el mismo que el del usuario que inició sesión.",
      685: "Error de configuracion para la entidad",
      401: "Su tiempo ha caducado, vuelva a hacer la solicitud",
      651: "La sesión ha caducado.",
      500: "No se puede procesar la solicitud",

      652: "Error en la respuesta del servicio",
      653: "Error en la respuesta del servicio",
      654: "Error en la respuesta del servicio",
      655: "Error en la respuesta del servicio",
      656: "Error en la respuesta del servicio",
      657: "Error en la respuesta del servicio",
      658: "Error en la respuesta del servicio",
      678: "Error en la respuesta del servicio",
      679: "Error en la respuesta del servicio",
      686: "Error al intentar construir propiedades de la transacción",
      687: "La cuenta introducida no es correcta",
      688: "Error al intentar construir propiedades de la transacción",
      689: "Error al intentar remover cuenta",
      690: "Error al intentar modificar cuenta",
      691: "Error al intentar listar cuentas",
      692: "Error al intentar validar información del proveedor",
      693: "Error al intentar validar entidad",
      694: "Error al intentar cargar clientes",
      695: "Error al intentar validar información del proveedor",
      696: "Error al intentar editar información del proveedor",
      697: "Error al intentar añadir nuevo anticipo automatico",
      698: "Error al intentar eliminar anticipo automatico",
      699: "No se han encontrado anticipos automaticos con estos parametros de búsqueda",
      700: "No se han encontrado facturas con estos parametros de búsqueda",
      701: "Error al intentar editar el anticipo automatico",
      702: "No se han encontrado facturas con estos parametros de búsqueda",
      703: "Error al intentar crear financiación",
      704: "Error en la respuesta del servicio",
      705: "Error al intentar obtener referencia Ruralvia",
      707: "No se ha configurado un destinatario para esta entidad financiera",
      1000: "Error al establecer conexión con el servicio",
      1001: "Error de autenticacion",
      1061: "La operativa necesaria para esta transacción no esta disponible",
      1086: "El terminal no exite",

      320: "Operación errónea",
      7: "Datos no encontados",
      6: "Pendiente de documentación",
      1: "Rechazada por Iberpay",
      4: "Rechazada por Entidad",

      709: "Datos no encontados",
      710: "Operación errónea",
      711: "La operativa necesaria para esta transacción no esta disponible",
      712: "El terminal no exite",
      713: "Cuenta existente",
      714: "Modificación no permitida",
      715: "IBAN inválido",
      716: "EL campo IBAN es obligatorio",
      717: "El campo ID Ofical del Proveedor es obligatorio ",
      720: "Bic no correcto",
      722: "Extensión no valida",
      723: "El proveedor no es titular de la cuenta, por favor verifique los datos y vuelva a intentarlo",
      724: "No se han encontrado datos para este criterio de búsqueda",
      725: "Datos no encontrados",
      726: "El campo de cliente es obligatorio",
      727: "Próxima fecha de vencimiento de la financiación",
      728: "No se encontraron datos para ese criterio de búsqueda",

      729: "El valor de campo referencia incorrecto",
      730: "IBAN erróneo",
      731: "Campo BIC obligatorio",
      732: "El importe a financiar es superior al importe pendiente de financiar de la factura",
      733: "Proveedor con referencia ya existente",
      734: "Las facturas ya están financiadas para este criterio de búsqueda",
      735: "Incohencia entre el ID. proveedor introducido y su cliente",
      736: "El campo total de facturas es obligatorio",
      737: "Debe informarse al menos una factura para la financiación",
      738: "El campo de importe nominal es obligatorio",
      739: "Su token ha expirado. Hemos reenviado el correo de validación para que pueda completar el proceso",
      740: "No es posible procesar su solicitud. Por favor, póngase en contacto con su oficina",
      741: "No es posible procesar su solicitud. Por favor, póngase en contacto con su oficina",
      1002: "Error desconocido",
      15935: "Modificación no permitida",
      16342: "IBAN inválido",
      25422: "EL campo IBAN es obligatorio",
      25828: "El campo ID Ofical del Proveedor es obligatorio ",
      7869: "Cuenta existente",
      "undefined": "Error"
    },
    ///
    invoices: {
      simulationMsj:
        "El interés, la comisión y los gastos que aparecen en la pantalla de simulación son orientativos. Los que se apliquen definitivamente serán los que figuren en la correspondiente liquidación que le efectúe la entidad el día que se realice el anticipo, de acuerdo con lo pactado entre el cliente pagador y la entidad",
      option1: "Anticipo(s) de factura creado(s)",
      option2:
        "Anticipo(s) de factura creado(s) pendiente (s) de autorizar por la entidad. La liquidación podrá variar en función de la fecha en que sea autorizado, de acuerdo con lo pactado entre el cliente pagador y la entidad",
      nosehaEncontradoData: "No hay datos que mostrar",
      resumenConfirmacionBaja:
        "Resumen y confirmación de baja del anticipo automático",
      resumenConfirmacionalta:
        "Resumen y confirmación de alta del anticipo automático",
      estado: "Estado",
      datosOperacion: "Datos de la operación",

      necitadjuntarCertificado:
        "Necesitamos que adjunte el certificado de titularidad de la cuenta para proceder a la validación de la misma",
      descargarnecitadjuntarCertificado:
        "Necesitamos que descargues el documento de verificación de titularidad, completes los datos correspondientes y adjuntes el mismo para proceder a la validación de la cuenta.",

      introduscaDatosRequeridosAltaCuentadeAbono:
        "Complete la documentación requerida para que su cuenta pueda ser validada.",
      ibanAbono: "IBAN DE ABONO",
      DetallesSimulacion22:
        "A continuación, se muestra el resumen de tu anticipo de facturas para su confirmación.",
      resumenautomatico:
        "A continuación, se muestra el resumen de tu anticipo de facturas para su confirmación",
      datosBajaAncipoAutomatico2:
        "A continuación, se muestra resumen sobre la baja del anticipo automático solicitado para tu confirmación",
      muestralistadoyresumendeanticipodefacturas:
        "A continuación, se muestra listado y resumen de anticipo de facturas automáticos solicitados.",
      solicitudDatosRequeridos2:
        "Solicitud de anticipo automático de facturas sobre clientes.",
      DetallesSimulacion:
        "A continuación, se muestra detalle sobre la simulación de liquidación de la consulta realizada.",
      ListadoFacturasRealizadas:
        "A continuación, se muestra listado de facturas de la consulta realizada",
      modificacionConsulta: "Modificación / Consulta",
      numerofacturasAnticipar: "Nº Facturas a Anticipar",
      uidadacionFina: "Total liquidación financiación:",
      fechaValor: "Fecha valor",
      IMPANTICIPABLE: "IMP. ANTICIPABLE",
      IMPANTICIPADO: "IMP. ANTICIPADO",
      IMPFACTURA: "IMP. FACTURA",
      FECHAVTO: "FECHA VTO.",
      fechaFactura: "FECHA FACTURA",
      clientePagador: "CLIENTE PAGADOR",
      NumeroFactura: "Nº DE FACTURA",
      filtrar: "Filtrar",
      TotalLiquidación: "Total liquidación",
      ResumenYconfirmacion: "Resumen y confirmación del anticipo de facturas",
      Importe: "Importe",
      escribaImporte: "Escriba un importe",
      volver: "volver",
      elImporteDelaComision:
        "El importe de la comisión está calculado teniendo en cuenta que se anticipa el 100% del importe anticipado de la factura. Si se desea anticipar un importe inferior, el valor real de los gastos de anticipo se muestran en la pantalla de confirmación de la operación.",
      elTipoDeInteres:
        "El tipo de interés que aparece en la pantalla de solicitud es orientativo. El tipo de interés definitivamente aplicable será el que figure en la correspondiente liquidación que le efectúe Caja Rural. acuerdo con lo pactado entre el cliente pagador y Caja Rural.",
      leInformamosMotivos:
        "Le informamos que por motivos de seguridad las facturas que desee anticipar se autorizarán en lotes de 10 en 10.",
      Confirmar: "Confirmar",
      importeTotalFinnciar: "Importe total a financiar",
      numeroFactura: "Nº Facturas a Anticipar",
      listadoAnticiposAutomaricos: "Listado de anticipos automáticos",
      nuevaAlta: "Nueva alta",
      introduscaDatosRealizarModificacionDescription:
        "Introduce los datos requeridos para realizar la modificación de la cuenta de abono y pulsa Modificar",
      modificarAnticipoAutomatico: "Modificar Anticipo automático",
      datosBajaAncipoAutomatico:
        "A continuación se muestran los datos de la baja de anticipo automático",
      empesaClintePagador: "Nombre Empresa Cliente Pagador",
      acontinuacionModificacionAnticiposAutomaticos:
        "A continuación se muestran los datos de la modificación de anticipo automático",
      resumenConfirmacionAnticipoAutomatico:
        "Resumen y confirmación de la modificación de anticipo automático",
      modificarAlguno:
        "Al modificar alguno de los datos de solicitud necesitamos que vuelvas a leer y aceptes los documentos con la información actualizada.",
      actualizarDocumentos: "Vamos a actualizar los documentos…",
      facturasAnticipar: "Facturas a Anticipar",
      fechaSolicitud: "Fecha de Solicitud",
      nombreEmpresaCliente: "Nombre Empresa Cliente Pagador",
      muestraDatos:
        " A continuación se muestran los datos del alta de anticipo automático",
      resumenConfirmacion: "Resumen y confirmación del anticipo automático",
      necesarioAcepte:
        "Es necesario que leas y aceptes la siguiente documentación:",
      cuentaAbono: "Cuenta de abono",
      datosRequeridos:
        "Introduce los datos requeridos para realizar la solicitud de anticipo automático y pulsa ACEPTAR.",
      datosSolicitud: "Datos de solicitud",
      anticipoAutomatico: "Anticipo automático",
      Modificación: "Modificación / Consulta",
      Baja: "Baja",
      Alta: "Alta",
      consultaFacturas: "Consulta de facturas",
      listadoFacturas: "Listado de facturas",
      empresaEmisor: "Nombre Cliente",
      fechaVencimiento: "Por fecha vencimiento",
      importeFactura: "Por Importe facturas",
      situacionFactura: "Situación facturas",
      quitarFiltros: "Quitar todos los filtros",
      SeMuestraElResumenDeAnticiposDeFacturas:
        "A continuación, se muestra el resumen de anticipo de facturas para su confirmación.",
      aticiposFacturas: "Anticipo de facturas",
      resumensimulacionLiquidacion:
        "Resumen y confirmación del anticipo de facturas",
      simulacionLiquidacion: "Simulación y liquidación",
      datosAnticipos: "Datos anticipo",
      lorem:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed consectetur posuere sollicitudin. Praesent sed mattis nibh, sed egestas erat.",
      nombrePagador: "Nombre Empresa Cliente Pagador",
      apoderadoPrueba:
        "APODERADO PRUEBAS EMISOR I RSI ENTIDAD FORMACIÓN EN PRODUCCIÓN",
      detallesFacturas: "Detalles de las facturas",
      Resumen: "Resumen",
      politicas: "Es necesario que leas y aceptes la siguiente documentación:",
      acceptTermsLabel: "Términos y Condiciones Particulares RuralConfirming",
      tipoConfirming: "Tipo Confirming",
      normal: "Normal (Gastos proveedor)",
      gastoDeudor: "Gastos deudor",
      from: "Desde",
      to: "Hasta",
      clientName: "Nombre Cliente",
      dateFrom: "Fecha Desde",
      dateTo: "Fecha Hasta",
      everySituation: "Todas las situaciones",
      anticipated: "Anticipada",
      partialyAnticipated: "Anticipada parcial",
      pendingConfirmation: "Pendiente de Confirmación",
      pendingTramit: "Pendiente de tramitar",
      pendingPayment: "Pendiente de pago",
      paidOnExpiration: "Pagada al vencimiento no anticipada",
      invoiceNumber: "Nº DE FACTURA",
      client: "CLIENTE PAGADOR",
      situation: "SITUACIÓN",
      date: "FECHA FACTURA",
      expDate: "FECHA VTO.",
      nominalAmount: "IMP. FACTURA",
      nominalAmountFinanced: "IMP. ANTICIPADO",
      paymentMethod: "FORMA DE PAGO",
      anticipable: "IMP. A ANTICIPAR",
      simulation: "Simulación",
      requestAdvance: "Solicitar anticipo",
      dateValue: "Fecha valor",
      totalLiquidation: "Total liquidación financiación:",
      interestPercent: "% INTERÉS",
      interest: "INTERÉS",
      interestDays: "",
      comision: "",
      taxes: "",
      expenses: "",
      impCobGtos: "",
      totalLiq: "",
      moreDataMessage: "Existen más facturas para anticipar de las que se muestran en la lista. Sólo es posible anticipar de 50 en 50. Puede utilizar los filtros existentes en la pantalla"

    },

    nav: {
      invoices: "Facturas",
      invoiceAdvance: "Anticipo de facturas",
      autoAdvance: "Anticipo automático",
      bankAccounts: "Cuenta de abono",
      personalDataManagement: "Gestión datos personales",
      selectOption: "Selecciona una opción a consultar",
      prev: "Anterior",
      next: "Siguiente",
      page: "Página",
    },

    supplierData: {
      editUserData3:
        "A continuación, se muestran un resumen de tus datos personales para tu confirmación.",
      SuAviso: "Se ulilizará para el envío de avisos",
      esNecesario:
        "Es necesario que leas y aceptes la siguiente documentación:",
      nombre: "Nombre",
      apoderadoPrueasEmisor:
        "APODERADO PRUEBAS EMISOR I RSI ENTIDAD FORMACIÓN EN PRODUCCIÓN",
      volver: "Volver",
      razonSocial: "Razón Social",
      confirmacionDatosExistente: "Confirmación de los datos existentes",
      confirmar: "Confirmar",
      envioAvisos: "Envío de avisos",
      contraseña: "Contraseña",
      repetirContraseña: "Repetir Contraseña",
      nombreAlias: "Nombre / Alias",
      email: "Email",
      datosAccesos: "Datos de acceso",
      cancelar: "Cancelar",
      siguiente: "Siguiente",
      fechaVenciminto: "Fecha de Vencimiento",
      importe: "Importe",
      numeroDeFactura: "Número de factura",
      datosFactura: "Datos de una factura",
      refenciaProvedor: "Referencia de proveedor",
      datosEmpresa: "Datos de la empresa",
      referenciaProvedor: "Registro de proveedores",
      editUserData2: "Modificación de datos de usuario registrados en su área.",
      gestionDatosPers: "Gestión datos personales",
      userData: "Datos Usuario",
      editUserData: "Modificar datos del usuario",
      clientCompanyName: "Nombre Empresa Cliente Pagador",
      usernameCompany: "Nombre Usuario / Empresa",
      clientePagador: "Cliente pagador relacionado",
      nifcif: "NIF/CIF/Otro",
      nifcifnie: "NIF/NIE/CIF/Otro ",
      address: "Dirección",
      editAddress: "Modificar dirección del usuario",
      postalCode: "Código Postal",
      city: "Localidad",
      state: "Provincia",
      contactData: "Datos de contacto",
      editContactData: "Modificar datos de contacto del usuario",
      phone: "Teléfono",
      fax: "Fax",
      notificationEmail: "Email de notificación",
      save: "Guardar",
      personalDataConfirmation: "Resumen y confirmación de datos personales",
      personalData: "Datos Personales",
      userDataMessage: "A Continuación se muestran los datos personales",
      acceptTermsTitle:
        "Es necesario que leas y aceptes la siguiente documentación",
      acceptTermsLabel:
        "He leído y acepto la cláusula de protección de datos (LOPD)",
      confirm: "Confirmar",
      goBack: "Volver",
      print: "Imprimir",
      finish: "Terminar",
    },

    Alertas: {
      Alertas: "Alertas",
    },

    index: {
      algoSalioMal: "Algo salio mal",
      errorInformacionFinanciera:
        "Error al cargar información de la entidad financiera",
    },

    accounts: {
      antiguedadPngJpejPDF:
        "Se debe adjuntar en formato PNG, JPG o PDF y tener una antiguedad máxima de 6 meses",
      estado: "Estado",
      datosOperacion: "Datos de la operación",
      necitadjuntarCertificado:
        "Necesitamos que adjunte el certificado de titularidad de la cuenta para proceder a la validacion de la misma",
      introduscaDatosRequeridosAltaCuentadeAbono:
        "Complete la documentación requerida para que su cuenta pueda ser validada.",
      sindescaragar:
        "Necesitamos que adjunte el certificado de titularidad de la cuenta para proceder a la validación de la misma",
      introduscaDatosRequeridosAltaCuentadeAbono2:
        "Necesitamos que descargues el documento de verificación de titularidad, completes los datos correspondientes y adjuntes el mismo para proceder a la validación de la cuenta.",

      adjuntarDocumentacion: "Adjuntar Documentación",
      descargarVerificacionTituaridad: "Descargar Verificación de Titularidad",
      bic: "BIC",
      confirmAddSubtitle2:
        "A continuación, se muestra el resumen de la modificación de tu cuenta para tu confirmación.",
      altaCuentaAbono:
        "Registro para dar de alta en el sistema una cuenta de abono.",
      listAcountManeger:
        "A continuación, se muestra listado de las cuentas de abono registradas en el sistema.",
      suCuentaEdit: "Su cuenta fue modificada de forma exitosa",
      ibanEspaña: "El IBAN debe ser de España",
      list: "Listado de Cuentas",
      accountNumber: "Cuenta de Abono",
      accountNumbers: "Cuentas de abono",
      description: "Descripción",
      newAccount: "Nueva alta",
      accountData: "Datos de alta",
      accountDataSubtitle: "Datos de la cuenta de abono",
      accountMessage:
        "Introduce los datos requeridos para realizar el alta de la cuenta de abono",
      confirmAddTitle: "Resumen y confirmación del alta de cuenta de abono",
      confirmEditTitle:
        "Resumen y confirmación de la modificación de cuenta de abono",
      confirmAddSubtitle:
        "A continuación, se muestran los datos de la cuenta de abono",
      confirmEditSubtitle:
        "A continuación, se muestran los datos de la cuenta de abono modificada",
      management: "Gestión",
      addAccount: "Alta",
      editAccount: "Modificar cuenta de abono",
      editAccountMessage:
        "Introduce los datos requeridos para realizar la Modificación y pulsa 'Modificar'",
      goBack: "Volver",
      modify: "Modificar",
      delete: "Eliminar",
      deleteAccount: "Eliminar Cuenta de Abono",
      deleteAccountMessage:
        "Si está seguro de eliminar esta cuenta de abono pulsa 'Eliminar'",
    },
    users: {
      principal: "Principal",
      confirmTitle: "Resumen y confirmación de alta de usuario",
      userData: "Datos de usuario",
      confirmSubtitle:
        "A continuación, se muestran los datos dados de alta según tu solicitud.",
      nameAlias: "Nombre / Alias",
      newUser: "Nuevo Usuario",
      list: "Listado de Usuarios",
      email: "Email",
      userArea: "Área de Usuario",
      userManagement: "Gestión de usuarios",
      createNewUser: "Crear Nuevo Usuario",
      createdMessage: "Usuario creado, verifique su correo para validarlo",
      createdMessageExistenteSinConfirmar:
        "El usuario ya existe, Se ha reenviado el correo de validación.",
      addUserSubtitle: "Introduce un Nombre / Alias de usuario y un Email",
      deleteUser: "Eliminar Usuario",
      deleteMessage:
        "Si estas seguro de eliminar este usuario pulsa 'Eliminar'",
      currentPassword: "Contraseña actual",
      newPassword: "Nueva contraseña",
      confirmPassword: "Validar nueva contraseña",
      confirm: "Confirmar",
      goBack: "Volver",
      print: "Imprimir",
      save: "Guardar",
      delete: "Eliminar",
      porConfirmar: "Por Confirmar",
      bloqueado: "Bloqueado",
    },
    terms: {
      agree: "De Acuerdo",
      disagree: "Cerrar",
    },

    progres: {
      Excel: "Excel",
      datosEmpresa: "Datos de empresa y factura",
      datosAcceso: "Datos de acceso",
    },
  },
  en: {
    MSAUTH01: "Log in",
    MSAUTH02: "Email",
    ///

    login: {
      loginError: "Incorrect user or password",
      olvidoContraseña: "Forgot your password",
      recuperarContraseña: "Recover password",
      solicitudDeCambio: "",
      verificarCorreo: "",
      aceptar: "",
      contraseña: "",
      introduzca: "",
      newContraseña: "",
      masInformacion: "Más información",
    },

    nav: {
      invoices: "Invoices",
      invoiceAdvance: "Invoice Advance",
      autoAdvance: "Automatic Advance",
      bankAccounts: "Bank Accounts",
      personalDataManagement: "Personal Data management",
      selectOption: "Select an option",
      prev: "Prev",
      next: "Next",
      page: "Page",
    },

    supplierData: {
      gestionDatosPers: "Manage Personal Data",
      userData: "User Data",
      editUserData: "Edit User Data",
      clientCompanyName: "Client Company Name",
      usernameCompany: "Username / Company",
      nifcif: "NIF/CIF/Otro",
      address: "Address",
      editAddress: "Edit user address",
      postalCode: "Postal Code",
      city: "City",
      state: "State",
      contactData: "Contact Data",
      editContactData: "Edit user contact data",
      phone: "Phone",
      fax: "Fax",
      notificationEmail: "Notification Email",
      save: "Save",
      personalDataConfirmation: "Personal Data Confirmation",
      personalData: "Personal Data",
      userDataMessage: "Confirm personal data changes",
      acceptTermsTitle: "Please read and accept the following documentation",
      acceptTermsLabel:
        "I have read and agree the terms and Data Policy (LOPD)",
      confirm: "Confirm",
      goBack: "Go Back",
      print: "Print",
    },
    accounts: {
      adjuntarDocumentacion: "Adjuntar Documentación",
      descargarVerificacionTituaridad: "Descargar Verificación de Titularidad",
      bic: "BIC",
      list: "List of Accounts",
      accountNumber: "Credit Account",
      accountNumbers: "Credit Accounts",
      description: "Descriptionn",
      newAccount: "New Account",
      accountData: "Account Information",
      accountDataSubtitle: "Credit Account Information",
      accountMessage: "Fill this form to add a new Credit Account",
      confirmAddTitle: "Confirmation of new Credit Account",
      confirmEditTitle: "Confirmation of Credit Account modification",
      confirmAddSubtitle: "New Credit Account Information",
      confirmEditSubtitle: "Edited Credit Account Information",
      management: "Management",
      addAccount: "Add Account",
      editAccount: "Edit Credit Account",
      editAccountMessage: "Fill the description and click on save 'Save'",
      goBack: "Go Back",
      modify: "Save",
      delete: "Delete",
      deleteAccount: "Delete Credit Account",
      deleteAccountMessage:
        "if you want to delete this account click on 'Delete'",
    },
    users: {
      confirmTitle: "Confirm User Creation",
      userData: "User Data",
      confirmSubtitle: "Order data",
      nameAlias: "Name / Alias",
      newUser: "New user",
      list: "Users List",
      email: "Email",
      userArea: "User Area",
      userManagement: "User Management",
      createNewUser: "Add new user",
      createdMessage: "New User Added",
      addUserSubtitle: "Input user Name / Alias and Email",
      deleteUser: "Delete User",
      deleteMessage: "If you want to remove this user press 'Delete'",
      currentPassword: "Current Password",
      newPassword: "New password",
      confirmPassword: "Validate New Password",
      confirm: "Confirm",
      goBack: "Go Back",
      print: "Print",
      save: "Save",
      delete: "Delete",
    },
    invoices: {
      ibanAbono: "IBAN DE ABONO",
      DetallesSimulacion22:
        "A continuación, se muestra el resumen de tu anticipo de facturas para su confirmación.",
      resumenautomatico:
        "A continuación, se muestra el resumen de tu anticipo de facturas para su confirmación",
      datosBajaAncipoAutomatico2:
        "A continuación, se muestra resumen sobre anticipo automático solicitado para su confirmación",
      muestralistadoyresumendeanticipodefacturas:
        "A continuación, se muestra listado y resumen de anticipo de facturas automáticos solicitados.",
      solicitudDatosRequeridos2:
        "Solicitud de anticipo automático de facturas sobre clientes.",
      DetallesSimulacion:
        "A continuación, se muestra detalle sobre la simulación de liquidación de la consulta realizada.",
      ListadoFacturasRealizadas:
        "A continuación, se muestra listado de facturas de la consulta realizada",
      modificacionConsulta: "Modificación / Consulta",
      numerofacturasAnticipar: "Nº Facturas a Anticipar",
      uidadacionFina: "Total liquidación financiación:",
      fechaValor: "Fecha valor",
      IMPANTICIPABLE: "IMP. ANTICIPABLE",
      IMPANTICIPADO: "IMP. ANTICIPADO",
      IMPFACTURA: "IMP. FACTURA",
      FECHAVTO: "FECHA VTO.",
      fechaFactura: "FECHA FACTURA",
      clientePagador: "CLIENTE PAGADOR",
      NumeroFactura: "Nº DE FACTURA",
      filtrar: "Filtrar",
      TotalLiquidación: "Total liquidación",
      ResumenYconfirmacion: "Resumen y confirmación del anticipo de facturas",
      Importe: "Importe",
      escribaImporte: "Escriba un importe",
      volver: "volver",
      elImporteDelaComision:
        "El importe de la comisión está calculado teniendo en cuenta que se anticipa el 100% del importe anticipado de la factura. Si se desea anticipar un importe inferior, el valor real de los gastos de anticipo se muestran en la pantalla de confirmación de la operación.",
      elTipoDeInteres:
        "El tipo de interés que aparece en la pantalla de solicitud es orientativo. El tipo de interés definitivamente aplicable será el que figure en la correspondiente liquidación que le efectúe Caja Rural. acuerdo con lo pactado entre el cliente pagador y Caja Rural.",
      leInformamosMotivos:
        "Le informamos que por motivos de seguridad las facturas que desee anticipar se autorizarán en lotes de 10 en 10.",
      Confirmar: "Confirmar",
      importeTotalFinnciar: "Importe total a financiar",
      numeroFactura: "Nº Facturas a Anticipar",
      listadoAnticiposAutomaricos: "Listado de anticipos automáticos",
      nuevaAlta: "Nueva alta",
      introduscaDatosRealizarModificacionDescription:
        "Introduce los datos requeridos para realizar la modificación de la cuenta de abono y pulsa Modificar",
      modificarAnticipoAutomatico: "Modificar Anticipo automático",
      datosBajaAncipoAutomatico:
        "A continuación se muestran los datos de la baja de anticipo automático",
      empesaClintePagador: "Nombre Empresa Cliente Pagador",
      acontinuacionModificacionAnticiposAutomaticos:
        "A continuación se muestran los datos de la modificación de anticipo automático",
      resumenConfirmacionAnticipoAutomatico:
        "Resumen y confirmación de la modificación de anticipo automático",
      modificarAlguno:
        "Al modificar alguno de los datos de solicitud necesitamos que vuelvas a leer y aceptes los documentos con la información actualizada.",
      actualizarDocumentos: "Vamos a actualizar los documentos…",
      facturasAnticipar: "Facturas a Anticipar",
      fechaSolicitud: "Fecha de Solicitud",
      nombreEmpresaCliente: "Nombre Empresa Cliente Pagador",
      muestraDatos:
        " A continuación se muestran los datos del alta de anticipo automático",
      resumenConfirmacion: "Resumen y confirmación del anticipo automático",
      necesarioAcepte:
        "Es necesario que leas y aceptes la siguiente documentación:",
      cuentaAbono: "Cuenta de abono",
      datosRequeridos:
        "Introduce los datos requeridos para realizar la solicitud de anticipo automático y pulsa ACEPTAR.",
      datosSolicitud: "Datos de solicitud",
      anticipoAutomatico: "Anticipo automático",
      Modificación: "Modificación / Consulta",
      Baja: "Baja",
      Alta: "Alta",
      consultaFacturas: "Consulta de facturas",
      listadoFacturas: "Listado de Facturas",
      empresaEmisor: "Nombre Cliente",
      fechaVencimiento: "Por fecha vencimiento",
      importeFactura: "Por Importe facturas",
      situacionFactura: "Situación facturas",
      quitarFiltros: "Quitar todos los filtros",
      SeMuestraElResumenDeAnticiposDeFacturas:
        "A continuación, se muestra el resumen de tu anticipo de facturas para su confirmación.",
      aticiposFacturas: "Anticipo de facturas",
      resumensimulacionLiquidacion:
        "Resumen y confirmación del anticipo de facturas",
      simulacionLiquidacion: "Simulación y liquidación",
      datosAnticipos: "Datos anticipo",
      lorem:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed consectetur posuere sollicitudin. Praesent sed mattis nibh, sed egestas erat.",
      nombrePagador: "Nombre Empresa Cliente Pagador",
      apoderadoPrueba:
        "APODERADO PRUEBAS EMISOR I RSI ENTIDAD FORMACIÓN EN PRODUCCIÓN",
      detallesFacturas: "Detalles de las facturas",
      Resumen: "Resumen",
      politicas: "Es necesario que leas y aceptes la siguiente documentación:",
      acceptTermsLabel: "Términos y Condiciones Particulares RuralConfirming",
      tipoConfirming: "Tipo Confirming",
      normal: "Normal (Gastos proveedor)",
      gastoDeudor: "Gastos deudor",
      from: "Desde",
      to: "Hasta",
      clientName: "Nombre Cliente",
      dateFrom: "Fecha Desde",
      dateTo: "Fecha Hasta",
      everySituation: "Todas las situaciones",
      anticipated: "Anticipada",
      partialyAnticipated: "Anticipada parcial",
      pendingConfirmation: "Pendiente de confirmación",
      pendingTramit: "Pendiente de tramitar",
      pendingPayment: "Pendiente de pago",
      paidOnExpiration: "Pagada al vencimiento no anticipada",
      invoiceNumber: "Nº DE FACTURA",
      client: "CLIENTE PAGADOR",
      situation: "SITUACIÓN",
      date: "FECHA FACTURA",
      expDate: "FECHA VTO.",
      nominalAmount: "IMP. FACTURA",
      nominalAmountFinanced: "IMP. ANTICIPADO",
      paymentMethod: "FORMA DE PAGO",
      anticipable: "IMP. A ANTICIPAR",
      simulation: "Simulación",
      requestAdvance: "Solicitar anticipo",
      dateValue: "Fecha valor",
      totalLiquidation: "Total liquidación financiación:",
      interestPercent: "% INTERÉS",
      interest: "INTERÉS",
      interestDays: "",
      comision: "",
      taxes: "",
      expenses: "",
      impCobGtos: "",
      totalLiq: "",
      moreDataMessage: "There are more invoices to anticipate than are shown in the list. It is only possible to anticipate 50 in 50. You can use the existing filters on the screen"
    },
    terms: {
      agree: "Agree",
      disagree: "Close",
    },
  },
};

export const i18n = new VueI18n({
  locale: "es",
  fallbackLocale: "en",
  messages,
});
